export interface ShippingService {
  id: string;
  key: string;
  description: string;
  supplierId: string;
  supplierKey: string;
  supplierName: string;
  shippingCost: number;
  default: number;
}
